<template>
  <div class="main-content">
    <div class="subtitle margin-top-16">
      {{ $t('message["1369"]') }}
    </div>
    <div
      v-fixed="{fixed, top}"
      class="role-select"
      :class="{'no-role-select': !formateRangeDatasStatus}"
    >
      <range
        type="dev"
        @handleRange="handleRangeDev"
      />
    </div>
    <date-select
      ref="devOverViewRef"
      :content-title="contentTitle"
      :date-data="dateData"
      :default-select-index="defaultSelectIndex"
      @callbackEvent="handleCallbackEvent"
      @dateTimeChange="handleDateChangeDev"
    />
    <div class="view-content-parent">
      <div
        v-for="(item,index) in devRecOverViewDatas"
        :key="index"
        class="view-content-children"
        :style="{width: viewContentChildrenWidth}"
      >
        <p>{{ item.name }}</p>
        <p><span>{{ item.num }}</span></p>
      </div>
    </div>
    <div>
      <date-select
        ref="devTendencyRef"
        :content-title="tendencyTitle"
        :date-data="tendencyDateData"
        :select-status="selectStatus"
        :default-select-index="defaultTendencySelectIndex"
        @callbackEvent="handleCallbackTendencyEvent"
        @level-change="handleLevelChange"
        @dateTimeChange="handleDateChangeTendency"
      />
      <div class="margin-top-24">
        <HChart
          :id="tendencyId"
          ref="tendencyRef"
          :option="tendencyOption"
        />
      </div>
    </div>
    <div>
      <!-- 分布 -->
      <date-select
        ref="devDistributeRef"
        :content-title="distributeTitle"
        :date-data="distributeDateData"
        :select-source-status="distributeSelectStatus"
        :default-select-index="defaultDistributeSelectIndex"
        @callbackEvent="handleCallbackDistributeEvent"
        @infoFromOrigin="handleInfoFromOrigin"
        @dateTimeChange="handleDateChangeDistribute"
      />
      <div class="margin-top-24 word_main">
        <!-- 环图 -->
        <HChart
          v-show="!isWordCloud"
          :id="distributeId"
          ref="distributeRef"
          :option="distributeOption"
          class="distribute-chart"
        />
        <!-- 词云图 -->
        <div
          v-show="isWordCloud"
          class="wordcloud"
        >
          <h-chart
            id="word"
            ref="wordRef"
            :option="wordcloudOption"
          />
          <div class="wordcloud_operate">
            <a-button
              icon="download"
              @click="toImport"
            >
              {{ $t('message["185"]') }}
            </a-button>
            <div class="pagin">
              <span
                @click="toPrev"
              ><i :class="['iconfont', 'iconicon-test43', wordLegendPage === 1 && 'pagin_null']" /></span>
              <a-dropdown :overlay-style="{'max-height': '200px', overflow: 'auto', border: '1px solid #ebebeb', 'border-radius': '4px', background: '#fff'}">
                <a-menu
                  slot="overlay"
                >
                  <a-menu-item
                    v-for="item in aPage"
                    :key="item"
                    @click="toPage(item + 1)"
                  >
                    {{ item + 1 }}/{{ devDistributelist.maxPage }}
                  </a-menu-item>
                </a-menu>
                <a-button>
                  {{ wordLegendPage }}/{{ devDistributelist.maxPage }} <a-icon type="down" />
                </a-button>
              </a-dropdown>
              <span
                @click="toNext"
              ><i :class="['iconfont', 'iconicon-test73', wordLegendPage === devDistributelist.maxPage && 'pagin_null']" /></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 数据 -->
    <div>
      <date-select
        ref="devTableDataRef"
        :type-default="developerTypeDefault"
        :content-title="dataTitle"
        :date-data="dataDateData"
        :type-select-status="dateInfoTypeSelectStatus"
        :default-select-index="defaultDataSelectIndex"
        @callbackEvent="handleCallbackDataEvent"
        @dateTimeChange="handleDateChangeTableData"
        @typeChange="handleTypeChangeTableData"
      />
      <table-data
        class="margin-top-24  margin-bottom-40"
        :table-data="tableData"
        :columns="tableColumns"
        :time="detailTimeData"
        :pagination="isShowPagination"
        type="dev"
        :table-config-options="tableConfigOptions"
        @changeParams="handleChangeParams"
      />
    </div>
    <a-spin
      v-if="loadingContent"
      class="spin-css"
    />
  </div>
</template>
<script>
import HighCharts from 'highcharts'
import DateSelect from './components/DateSelectComponent.vue'
import TableData from './components/TableData.vue'
import Range from './components/Range.vue'
import HChart from '@/components/pc/HighChart.vue'
import { highchartLineOption, distributePieOptions, highChartWordCloudOption } from '@/lib/chart-option'
import { overviewTendency, overviewData } from '@/lib/statistic-utils.js'
import { mapState, mapActions, mapMutations } from 'vuex'
import { fixed } from '@/lib/directives'

export default {
  components: {
    DateSelect,
    HChart,
    TableData,
    Range
  },
  directives: { fixed },
  data () {
    return {
      tableColumns: [],
      tableData: [],
      isShowPagination: false,
      tablecolumnsArray: [],
      dataTitle: this.$t('message["1130"]'),
      dateInfoTypeSelectStatus: true, // 是否显示信息类型筛选
      tendencyDataList: [],
      devDistributelist: {},
      overviewTimeData: { timetype: 5 },
      detailTimeData: { timetype: 5 },
      distributeTimeData: { timetype: 5 },
      tendencyTimeData: { timetype: 6 },
      levelValue: 0,
      defaultDataSelectIndex: 3,
      dataDateData: overviewData,
      distributeId: 'distributeId',
      distributeTitle: this.$t('message["293"]'),
      distributeSelectStatus: true,
      defaultDistributeSelectIndex: 3,
      distributeDateData: overviewData,
      tendencyId: 'tendencyId',
      distributeOption: distributePieOptions(),
      tendencyOption: highchartLineOption(),
      wordcloudOption: highChartWordCloudOption(),
      selectStatus: true,
      tendencyTitle: this.$t('message["895"]'),
      contentTitle: this.$t('message["346"]'),
      defaultSelectIndex: 3,
      defaultTendencySelectIndex: 2,
      tendencyDateData: overviewTendency,
      dateData: overviewData,
      tableDataType: null,
      tableConfigOptions: [],
      // 数据类型默认值
      developerTypeDefault: 0,
      isWordCloud: false,
      wordLegendPage: 1,
      aPage: [],
      top: 0,
      fixed: true
    }
  },
  computed: {
    ...mapState('statistic', ['devRecOverViewDatas', 'tendencyDataArray', 'devDistributeDatas', 'detailTableDatas', 'loadingContent', 'staticType', 'formateRangeDatasStatus']),
    viewContentChildrenWidth () {
      let count = this.devRecOverViewDatas.length
      return parseInt(((1040 - (count - 1) * 20) / count)) + 'px'
    }
  },
  watch: {
    tendencyDataArray (val) {
      if (!val) return
      this.tendencyDataList = this.formateTendencyData(val)
      this.drawLine()
      document.title = `${this.$t('message["1369"]')}-${this.$store.state.baseinfo.projectname}-${this.$store.state.baseinfo.comname}`
    },
    devDistributeDatas (val) {
      if (!val) return
      this.isWordCloud = 'hotKeywords' in val
      if (this.isWordCloud) {
        this.devDistributelist = val
        this.aPage = Array.from(Array(val.maxPage), (v, k) => k)
        this.drawWordCloud()
      } else {
        this.devDistributelist = this.formateDistributeData(val)
        this.drawPie()
      }
    },
    detailTableDatas (val) {
      if (!val) return
      this.isShowPagination = !!val.count
      this.tableColumns = this.formateTableColmunsData(val.config)
      this.tableData = this.formateTableDatas(val.data)
      if (val.total) {
        this.tableData = this.tableData.concat(this.formateTableDatas(val.total, 'total', val.maxPage))
      }
      // console.log(JSON.stringify(this.tableData, null, 2))
    }
  },
  mounted () {
    this.fetchGetDevRecOverView(this.overviewTimeData)
    this.fetchGetDTendencyDatas(this.tendencyTimeData)
    this.fetchDevDistributeDatas(this.distributeTimeData)
    this.fetchGetDetailTableDatas({ ...this.detailTimeData, 'page': 1 })
    this.fetchStaticTypes()
    if (this.tendencyDataArray.length > 0) {
      this.tendencyDataList = this.formateTendencyData(this.tendencyDataArray)
      this.drawLine()
    }
    if (this.devDistributeDatas.length > 0) {
      this.devDistributelist = this.formateDistributeData(this.devDistributeDatas)
      this.drawPie()
    }
  },
  methods: {
    ...mapActions('statistic', ['fetchGetDevRecOverView', 'fetchGetDTendencyDatas', 'fetchDevDistributeDatas', 'fetchGetDetailTableDatas', 'fetchStaticTypes']),
    ...mapMutations('statistic', ['setIsTablePShow']),
    drawLine () {
      this.$refs.tendencyRef.chartObj.series[0].update({
        name: this.$t('message["1376"]'),
        data: this.tendencyDataList.data
      })
      let isNull = this.tendencyDataList.data.every(item => item === 0)
      this.$refs.tendencyRef.chartObj.yAxis[0].setExtremes(0, isNull ? 10 : null)
      this.$refs.tendencyRef.chartObj.xAxis[0].setCategories(this.tendencyDataList.category)
    },
    // 分布-饼图更新数据
    drawPie () {
      /* this.$refs.distributeRef.chartObj.title.update({
        text: `<p style="font-size: 14px;color:#666666;text-align:center">信息量</p><p style="font-size: 48px;text-align:center;color: #333333;">${this.devDistributelist.total}</p>`
      }) */
      this.$refs.distributeRef.chartObj.subtitle.update({
        text: this.devDistributelist.total
      })
      this.$refs.distributeRef.chartObj.series[0].update({
        type: 'pie',
        innerSize: '80%',
        name: this.$t('message["1374"]'),
        data: this.devDistributelist.data
      })

      let _this = this
      this.$refs.distributeRef.chartObj.series[0].points.forEach(function (p) {
        HighCharts.addEvent(p.legendItem.element, 'mouseover', function (e) {
          // console.log(_this.$refs.distributeRef.chartObj, e)
          _this.$refs.distributeRef.chartObj.tooltip.refresh(p)
        })
        HighCharts.addEvent(p.legendItem.element, 'mouseout', function (e) {
          _this.$refs.distributeRef.chartObj.tooltip.hide()
        })
      })
    },
    drawWordCloud () {
      this.$refs.wordRef.chartObj.series[0].update({
        type: 'wordcloud',
        innerSize: '90%',
        data: this.prepareWordCloud(this.devDistributelist.hotKeywords),
        arr: this.devDistributelist.data
      })
    },
    // 减少词云元数据之间的倍数
    prepareWordCloud (value) {
      let aWeight = value.map(item => item.weight)
      let max = Math.max.apply(null, aWeight) // 最大值
      let middle = Math.floor(max / 2) // 基数
      let wordKeys = value.map(item => {
        item.name = item.name.length > 10 ? item.name.slice(0, 10) : item.name
        item.weight = (max / item.weight) > middle ? item.weight + middle : item.weight
        return item
      })
      return wordKeys
    },
    handleChangeParams (value) {
      if (!value) return
      const { roleid } = this.detailTimeData
      if (roleid === '0') {
        delete value.roleid
        delete value.userid
        delete value.groupid
      }
      this.detailTimeData = Object.assign({}, this.detailTimeData, value)
    },
    handleRangeDev (value, b) {
      delete this.overviewTimeData.roleid
      delete this.overviewTimeData.groupid
      delete this.overviewTimeData.userid
      delete this.overviewTimeData.ismerge
      delete this.tendencyTimeData.roleid
      delete this.tendencyTimeData.groupid
      delete this.tendencyTimeData.userid
      delete this.tendencyTimeData.ismerge
      delete this.detailTimeData.roleid
      delete this.detailTimeData.groupid
      delete this.detailTimeData.userid
      delete this.detailTimeData.ismerge
      delete this.distributeTimeData.roleid
      delete this.distributeTimeData.groupid
      delete this.distributeTimeData.userid
      delete this.distributeTimeData.ismerge
      if (value.length > 0) {
        // if (value[0] !== 'roleid-0') {
        value.map(item => {
          const array = item.split('-')
          const [name, key] = array
          this.overviewTimeData[name] = key
          this.tendencyTimeData[name] = key
          this.detailTimeData[name] = key
          this.distributeTimeData[name] = key
          if (b) {
            this.overviewTimeData['ismerge'] = 1
            this.tendencyTimeData['ismerge'] = 1
            this.detailTimeData['ismerge'] = 1
            this.distributeTimeData['ismerge'] = 1
          }
        })
        // }
      }
      this.fetchGetDevRecOverView(this.overviewTimeData)
      this.fetchGetDTendencyDatas({ ...this.tendencyTimeData })
      this.fetchDevDistributeDatas(this.distributeTimeData)
      this.fetchGetDetailTableDatas({ ...this.detailTimeData, 'page': 1 })
    },
    // 分布-选择信息来源
    handleInfoFromOrigin (value) {
      if (Array.isArray(value)) {
        const [first, second] = value
        if (second) {
          this.distributeTimeData.from = second
        } else if (first) {
          this.distributeTimeData.from = first
        } else {
          delete this.distributeTimeData.from
        }
      } else {
        delete this.distributeTimeData.from
      }
      this.fetchDevDistributeDatas({ ...this.distributeTimeData })
    },
    handleDateChangeDev (value) {
      if (Array.isArray(value)) {
        if (value[0]) {
          this.$refs.devOverViewRef.initdDteSelectIndex()
          this.overviewTimeData.starttime = value[0]
          this.overviewTimeData.endtime = value[1]
          delete this.overviewTimeData.timetype
          this.fetchGetDevRecOverView(this.overviewTimeData)
        }
      }
    },
    handleDateChangeTendency (value) {
      if (Array.isArray(value)) {
        if (value[0]) {
          this.$refs.devTendencyRef.initdDteSelectIndex()
          this.tendencyTimeData.starttime = value[0]
          this.tendencyTimeData.endtime = value[1]
          delete this.tendencyTimeData.timetype
          this.fetchGetDTendencyDatas({ ...this.tendencyTimeData })
        }
      }
    },
    handleDateChangeDistribute (value) {
      if (Array.isArray(value)) {
        if (value[0]) {
          this.$refs.devDistributeRef.initdDteSelectIndex()
          this.distributeTimeData.starttime = value[0]
          this.distributeTimeData.endtime = value[1]
          delete this.distributeTimeData.timetype
          this.fetchDevDistributeDatas(this.distributeTimeData)
        }
      }
    },
    /* 数据模块 - 日期选择事件 */
    handleDateChangeTableData (value) {
      if (Array.isArray(value)) {
        if (value[0]) {
          this.$refs.devTableDataRef.initdDteSelectIndex()
          this.detailTimeData.starttime = value[0]
          this.detailTimeData.endtime = value[1]
          delete this.detailTimeData.timetype
          // this.developerTypeDefault = 0
          this.fetchGetDetailTableDatas({ ...this.detailTimeData, page: 1 })
        }
      }
    },
    formateTendencyData (array) {
      const valueJson = {
        category: [],
        data: []
      }
      array.map(value => {
        valueJson.category.push(value.name)
        valueJson.data.push(value.num)
      })
      return valueJson
    },
    formateDistributeData (obj) {
      const json = {
        total: obj.total,
        data: []
      }
      if (Array.isArray(obj.data)) {
        obj.data.map(value => {
          const pers = value.per.substring(0, value.per.length - 1).substring(0, 4) * 1
          json.data.push({
            name: value.name,
            y: pers,
            num: value.num,
            levelinfo: value.levelinfo
          })
        })
      }
      return json
    },
    formateTableColmunsData (array) {
      let tempArray = []
      this.tablecolumnsArray = []
      if (Array.isArray(array)) {
        array.map(value => {
          this.tablecolumnsArray.push(value.sortId)
          if (value.options) {
            this.tableConfigOptions = Object.values(value.options)
          }
          // if (value.sortable) {
          //   if (value.sortId === 'rank') {
          //     tempArray.push({
          //       title: value.name,
          //       key: value.sortId,
          //       dataIndex: value.sortId,
          //       scopedSlots: { customRender: 'rank' },
          //       sorter: (a, b) => a[value.sortId] - b[value.sortId]
          //     })
          //   } else if (value.sortId === 'name') {
          //     tempArray.push({
          //       title: value.name,
          //       key: value.sortId,
          //       dataIndex: value.sortId,
          //       scopedSlots: { customRender: 'name' },
          //       filters: this.formateFilter(value.options),
          //       filterMultiple: false,
          //       sorter: (a, b) => a[value.sortId] - b[value.sortId]
          //     })
          //   } else if (value.sortId === 'all') {
          //     tempArray.push({
          //       title: value.name,
          //       key: value.sortId,
          //       dataIndex: value.sortId,
          //       scopedSlots: {
          //         customRender: 'all',
          //         filterDropdown: 'filterDropdown'
          //       },
          //       onFilterDropdownVisibleChange: visible => {
          //         if (visible) {
          //           this.setIsTablePShow(true)
          //         } else {
          //           this.setIsTablePShow(false)
          //         }
          //       }
          //     })
          //   } else {
          //     tempArray.push({
          //       title: value.name,
          //       key: value.sortId,
          //       dataIndex: value.sortId,
          //       sorter: (a, b) => a[value.sortId] - b[value.sortId]
          //     })
          //   }
          // } else {
          //   if (value.sortId === 'rank') {
          //     tempArray.push({
          //       title: value.name,
          //       key: value.sortId,
          //       dataIndex: value.sortId,
          //       scopedSlots: { customRender: 'rank' },
          //       width: 60
          //     })
          //   } else if (value.sortId === 'name') {
          //     tempArray.push({
          //       title: value.name,
          //       key: value.sortId,
          //       dataIndex: value.sortId,
          //       filters: this.formateFilter(value.options),
          //       filterMultiple: false,
          //       scopedSlots: { customRender: 'name' },
          //       width: 170
          //     })
          //   } else if (value.sortId === 'all') {
          //     tempArray.push({
          //       title: value.name,
          //       key: value.sortId,
          //       dataIndex: value.sortId,
          //       scopedSlots: {
          //         customRender: 'all',
          //         filterDropdown: 'filterDropdown'
          //       },
          //       onFilterDropdownVisibleChange: visible => {
          //         if (visible) {
          //           this.setIsTablePShow(true)
          //         } else {
          //           this.setIsTablePShow(false)
          //         }
          //       }
          //     })
          //   } else {
          //     tempArray.push({
          //       title: value.name,
          //       key: value.sortId,
          //       dataIndex: value.sortId
          //     })
          //   }
          // }
          if (value.sortId === 'rank') {
            tempArray.push({
              title: value.name,
              key: value.sortId,
              dataIndex: value.sortId,
              scopedSlots: { customRender: 'rank' },
              width: 60
            })
          } else if (value.sortId === 'name') {
            tempArray.push({
              title: value.name,
              key: value.sortId,
              dataIndex: value.sortId,
              // filters: this.formateFilter(value.options),
              // filterMultiple: false,
              options: this.formateFilter(value.options),
              scopedSlots: { customRender: 'name', filterDropdown: 'filterDropdownName' },
              width: 140,
              filterIcon: <em class="anticon anticon-filter th-filter-icon"><i class="iconfont iconicon-test19"></i></em>
            })
          } else if (value.sortId === 'all') {
            tempArray.push({
              title: value.name,
              key: value.sortId,
              dataIndex: value.sortId,
              scopedSlots: {
                customRender: 'all'
              },
              width: 140,
              ellipsis: true
            })
          } else if (value.sortId === 'fromtype') {
            tempArray.push({
              title: value.name,
              key: value.sortId,
              dataIndex: value.sortId,
              scopedSlots: {
                customRender: 'fromtype',
                filterDropdown: 'filterDropdown'
              },
              filterIcon: <em class="th-filter-icon anticon anticon-filter"><i class="iconfont iconicon-test20"></i></em>,
              onFilterDropdownVisibleChange: visible => {
                if (visible) {
                  this.setIsTablePShow(true)
                } else {
                  this.setIsTablePShow(false)
                }
              },
              width: 160,
              ellipsis: true
            })
          } else {
            tempArray.push({
              title: value.name,
              key: value.sortId,
              dataIndex: value.sortId
            })
          }
        })
      }
      return tempArray
    },
    formateTableDatas (array, flag, maxPage) {
      let tempArray = []
      let tpadv = []
      if (Array.isArray(array)) {
        if (flag) {
          if (maxPage && maxPage <= 1) {
            tpadv = array.slice(1)
          } else {
            tpadv = array
          }
        } else {
          tpadv = array
        }
        tpadv.map((value, indexs) => {
          let json = {}
          value.map((values, index) => {
            json['key'] = 'dev' + Math.random()
            // console.log(json['key'])
            if (flag) {
              if (index === 0) {
                if (indexs === 0) {
                  if (maxPage && maxPage > 1) {
                    json[this.tablecolumnsArray[index]] = this.$t('message["177"]')
                  } else {
                    json[this.tablecolumnsArray[index]] = this.$t('message["910"]')
                  }
                } else {
                  json[this.tablecolumnsArray[index]] = this.$t('message["910"]')
                }
                json[this.tablecolumnsArray[index + 1]] = values
              } else {
                json[this.tablecolumnsArray[index + 1]] = values
              }
            } else {
              if (Array.isArray(values)) {
                const num = this.tablecolumnsArray.includes('rank') ? 2 : 1
                const columnsChildArray = JSON.parse(JSON.stringify(this.tablecolumnsArray)).splice(num)
                let tablechildDatas = []
                tablechildDatas = values.map((item) => {
                  let jsonchild = {}
                  item.forEach((val, index) => {
                    jsonchild[columnsChildArray[index]] = val
                    jsonchild['key'] = 'child' + Math.random()
                  })
                  return jsonchild
                })
                json['childTableData'] = values = tablechildDatas
              } else {
                json[this.tablecolumnsArray[index]] = values
              }
            }
          })
          tempArray.push(json)
        })
      }
      return tempArray
    },
    formateFilter (object) {
      const keys = Object.keys(object)
      const values = Object.values(object)
      const temp = []
      if (Array.isArray(keys)) {
        keys.map((value, index) => {
          let json = {
            text: values[index][0],
            value: value
          }
          temp.push(json)
        })
      }
      return temp
    },
    handleCallbackEvent (val) {
      delete this.overviewTimeData.starttime
      delete this.overviewTimeData.endtime
      this.overviewTimeData.timetype = val.key
      this.fetchGetDevRecOverView(this.overviewTimeData)
    },
    handleCallbackTendencyEvent (val) {
      delete this.tendencyTimeData.starttime
      delete this.tendencyTimeData.endtime
      this.tendencyTimeData.timetype = val.key
      this.fetchGetDTendencyDatas({ ...this.tendencyTimeData })
    },
    handleCallbackDistributeEvent (val) {
      delete this.distributeTimeData.starttime
      delete this.distributeTimeData.endtime
      this.distributeTimeData.timetype = val.key
      this.fetchDevDistributeDatas(this.distributeTimeData)
    },
    /* 数据模块 - 今日/本周/本月/本年 切换事件 */
    // 切换日期
    handleCallbackDataEvent (val) {
      delete this.detailTimeData.starttime
      delete this.detailTimeData.endtime
      this.detailTimeData.timetype = val.key
      // this.developerTypeDefault = 0
      this.fetchGetDetailTableDatas({ ...this.detailTimeData, 'page': 1 })
    },
    handleLevelChange (val) {
      if (val === '-1') {
        delete this.tendencyTimeData.level
      } else {
        this.tendencyTimeData.level = val
      }
      this.fetchGetDTendencyDatas({ ...this.tendencyTimeData })
    },
    handleTypeChangeTableData (obj) {
      this.developerTypeDefault = obj.info_type
      this.detailTimeData = Object.assign(this.detailTimeData, obj)
      if (obj.info_type === 0) {
        this.$delete(this.detailTimeData, 'info_type')
      }
      if (!obj.info_sign) {
        this.$delete(this.detailTimeData, 'info_sign')
      }
      this.fetchGetDetailTableDatas({ ...this.detailTimeData, 'page': 1 })
    },
    toPrev () {
      // console.log(this.devDistributelist)
      const currentPage = this.devDistributelist.currentPage
      if (currentPage > 1) {
        this.wordLegendPage = this.devDistributelist.currentPage - 1
        this.fetchDevDistributeDatas({ ...this.distributeTimeData, page: this.wordLegendPage })
      }
    },
    toNext () {
      // console.log(this.devDistributelist)
      const currentPage = this.devDistributelist.currentPage
      if (currentPage < this.devDistributelist.maxPage) {
        this.wordLegendPage = this.devDistributelist.currentPage + 1
        this.fetchDevDistributeDatas({ ...this.distributeTimeData, page: this.wordLegendPage })
      }
    },
    // 选择页码跳转
    toPage (page) {
      this.wordLegendPage = page
      this.fetchDevDistributeDatas({ ...this.distributeTimeData, page })
    },
    // 导出标签
    toImport () {
      console.log('导出', this.devDistributelist)
      const { downloadUrl } = this.devDistributelist
      window.location.href = downloadUrl
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/statistic/style.scss';
.dev-info-amount {
  font-size: 14px;
  color: #b3b3b3;
  margin-bottom: 12px;
  text-align: center;
}
.spin-css {
  position: absolute;
  top: 50%;
  left: 50%;
}
.dev-info-text {
  text-align: center;
  font-size: 48px !important;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: center;
  color: #333333;
  border: solid 1px;
}
.word_main {
  position: relative;
}
.wordcloud {
  .wordcloud_operate {
    display: inline-block;
    position: absolute;
    right: 120px;
    bottom: 40px;
    .pagin {
      display: inline-block;
      ::v-deep .ant-btn {
        background: #fff;
        margin: 0 8px;
        vertical-align: middle;
      }
      span {
        display: inline-block;
        width: 32px;
        height: 32px;
        border-radius: 4px;
        border: 1px solid #d6d6d6;
        text-align: center;
        line-height: 32px;
        vertical-align: middle;
        i {
          color: #333;
        }
        .pagin_null {
          color: #d6d6d6;
        }
      }
      span:hover {
        cursor: pointer;
      }
    }
    ::v-deep .ant-dropdown .ant-dropdown-placement-topLeft {
      height: 200px;
      overflow: auto
    }
  }
}
/* .distribute-chart ::v-deep {
  .highcharts-tooltip {
    fill: blue;
    fill-opacity: 1;
    background: rgba(255,255,255,0.95);
  }
  .highcharts-tooltip-box {
    fill: red;
    stroke: red;
    fill-opacity: 1;
    background: rgba(255,255,255,0.95);
  }
} */
</style>
